import { render, staticRenderFns } from "./dev-box3.vue?vue&type=template&id=1c563d08&scoped=true&"
import script from "./dev-box3.vue?vue&type=script&lang=js&"
export * from "./dev-box3.vue?vue&type=script&lang=js&"
import style0 from "./dev-box3.vue?vue&type=style&index=0&id=1c563d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c563d08",
  null
  
)

export default component.exports